import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { Asset, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AssetState {
    [key: string]: Asset;
}

const initialState: AssetState = {};

const initialLoadAction = createAction<{ assets: {
    [assetId: string]: Asset;
}; }>('InitialLoad');
const assetRecordAction = createAction<Asset>(CoreMsgTypes.Asset);

const assetSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                initialLoadAction,
                (_state, action) => action.payload.assets
            )
            .addCase(
                assetRecordAction,
                (state, action) => {
                    return {
                        ...state,
                        [action.payload.AssetId]: action.payload
                    };
                }
            )
            .addDefaultCase(state => state);
    }
});

export default assetSlice.reducer;